import { Dict } from '../../models';
import {
  ApiResponse,
  ListSort,
  MediaFile,
  OcrDocumentTag,
  OcrList,
  PaginatedApiResponse,
  S3FileTracker,
} from '../models';
import * as http from './http';
import ApiService from './service';

export class OCRService extends ApiService {
  public async getOCRList(
    status: string,
    data: {
      batchId: string;
      page: number;
      search?: string;
      perPage: number;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<OcrList> & { lastUpdatedAt: Date }> {
    const url = `${this.apiDomain}/api/ocr/${status}`;

    const resposne = await http.post<PaginatedApiResponse<OcrList>>(
      url,
      data,
      this.store
    );
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }

  public async getAllOCRList(
    status: string,
    data: {
      batchId: string;
      page: number;
      search?: string;
      perPage: number;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<OcrList> & { lastUpdatedAt: Date }> {
    const url = `${this.apiDomain}/api/ocr`;

    const resposne = await http.post<PaginatedApiResponse<OcrList>>(
      url,
      data,
      this.store
    );
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }

  async uploadOcrDocuments(
    id: string,
    ocrDocuments?: { ocrDocument: MediaFile; tagGroup: string }[]
  ) {
    const url = `${this.apiDomain}/api/ocr/upload-documents/${id}`;
    const response = await http.post<ApiResponse<OcrList>>(
      url,
      { ocrDocuments },
      this.store
    );
    return response.data;
  }

  async uploadOcrDocumentsByAdmin(
    id: string,
    ocrDocuments?: { ocrDocument: MediaFile; tagGroup: string }[]
  ) {
    const url = `${this.apiDomain}/api/ocr/admin/upload-documents/${id}`;
    const response = await http.post<ApiResponse<OcrList>>(
      url,
      { ocrDocuments },
      this.store
    );
    return response.data;
  }

  async ChangeOcrDocumentTag(
    id: string,
    data: {
      tagGroup: string;
      _id: string;
    }
  ) {
    const url = `${this.apiDomain}/api/ocr/${id}/move`;
    const response = await http.put<ApiResponse<OcrList>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  async requestApproval(id: string) {
    const url = `${this.apiDomain}/api/ocr/request-admin-review/${id}`;
    const response = await http.put<ApiResponse<OcrList>>(url, {}, this.store);
    return response.data;
  }

  async requestGCApproval(id: string) {
    const url = `${this.apiDomain}/api/ocr/request-gc-review/${id}`;
    const response = await http.put<ApiResponse<OcrList>>(url, {}, this.store);
    return response.data;
  }

  async approveDocuments(id: string) {
    const url = `${this.apiDomain}/api/ocr/approve/${id}`;
    const response = await http.put<ApiResponse<OcrList>>(url, {}, this.store);
    return response.data;
  }

  async rejectDocumentByGC(
    id: string,
    data: {
      rejectionComments: string;
      fileId: string;
    }
  ) {
    const url = `${this.apiDomain}/api/ocr/gc/reject-file/${id}`;
    const response = await http.post<ApiResponse<OcrList>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  async rejectDocumentByAdmin(
    id: string,
    data: {
      rejectionComments: string;
      fileId: string;
    }
  ) {
    const url = `${this.apiDomain}/api/ocr/admin/reject-file/${id}`;
    const response = await http.post<ApiResponse<OcrList>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  async assignToSalesMan(
    id: string,
    data?: {
      rejectionComments: string;
    }
  ) {
    const url = `${this.apiDomain}/api/ocr/assign-to-sales-man/${id}`;
    const response = await http.post<ApiResponse<OcrList>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  async assignToAdmin(
    id: string,
    data?: {
      rejectionComments: string;
    }
  ) {
    const url = `${this.apiDomain}/api/ocr/assign-to-admin/${id}`;
    const response = await http.post<ApiResponse<OcrList>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  async deleteFileById(id: string, fileId: string) {
    const url = `${this.apiDomain}/api/ocr/delete-file/${id}?fileId=${fileId}`;
    const response = await http.remove<ApiResponse<OcrList>>(url, this.store);
    return response.data;
  }

  async markAsComplete(id: string) {
    const url = `${this.apiDomain}/api/ocr/mark-as-complete/${id}`;
    const response = await http.put<ApiResponse<OcrList>>(url, {}, this.store);
    return response.data;
  }

  async deleteAllFile(id: string) {
    const url = `${this.apiDomain}/api/ocr/delete-all/${id}`;
    const response = await http.remove<ApiResponse<OcrList>>(url, this.store);
    return response.data;
  }

  public async downloadOcr(
    data: {
      search?: string;
      columns: { label: string; source?: string }[];
      isDeal?: boolean;
    } & ListSort &
      Dict
  ): Promise<void> {
    const url = `${this.apiDomain}/api/ocr/download`;

    const resposne = await http.downloadPostData(url, data, this.store);
    http.saveDownloadedFile(
      resposne.data,
      'application/application/vnd.openxmlformats',
      `ocr-${new Date()}.xlsx`
    );
  }

  public async downloadOcrBatches(
    data: {
      search?: string;
      // columns: { label: string; source?: string }[];
      isDeal?: boolean;
    } & ListSort &
      Dict
  ): Promise<void> {
    const url = `${this.apiDomain}/api/ocr/batches/download`;

    const resposne = await http.downloadPostData(url, data, this.store);
    http.saveDownloadedFile(
      resposne.data,
      'application/application/vnd.openxmlformats',
      `ocr-batches-${new Date()}.xlsx`
    );
  }

  async adminApproveDocuments(id: string, fileId: string) {
    const url = `${this.apiDomain}/api/ocr/admin/approve-file/${id}`;
    const response = await http.post<ApiResponse<OcrList>>(
      url,
      { fileId },
      this.store
    );
    return response.data;
  }
  async approveDocumentByGC(id: string, fileId: string) {
    const url = `${this.apiDomain}/api/ocr/gc/approve-file/${id}`;
    const response = await http.post<ApiResponse<OcrList>>(
      url,
      { fileId },
      this.store
    );
    return response.data;
  }

  async markMissingDocuments(
    id: string,
    data?: {
      missingDocumentTags: string[];
    }
  ) {
    const url = `${this.apiDomain}/api/ocr/mark-missing-documents/${id}`;
    const response = await http.post<ApiResponse<OcrList>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  async resubmitDocumentByAdmin(
    id: string,
    data: { rejectedFileId: string; newFileId: string[] }
  ) {
    const url = `${this.apiDomain}/api/ocr/admin/map-rejected-file/${id}`;
    const response = await http.post<ApiResponse<OcrList>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  async resubmitDocument(
    id: string,
    data: { rejectedFileId: string; newFileId: string[] }
  ) {
    const url = `${this.apiDomain}/api/ocr/gc/map-rejected-file/${id}`;
    const response = await http.post<ApiResponse<OcrList>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  async revokeApprovedDocument(id: string, fileId: string) {
    const url = `${this.apiDomain}/api/ocr/revoke-approved-file/${id}`;
    const response = await http.post<ApiResponse<OcrList>>(
      url,
      { fileId },
      this.store
    );
    return response.data;
  }

  async revokeRejectedDocument(id: string, fileId: string) {
    const url = `${this.apiDomain}/api/ocr/revoke-rejected-file/${id}`;
    const response = await http.post<ApiResponse<OcrList>>(
      url,
      { fileId },
      this.store
    );
    return response.data;
  }

  public async getOcrDocumentTags(): Promise<OcrDocumentTag[]> {
    const url = `${this.apiDomain}/api/ocr-document-tag/list`;

    const resposne = await http.get<ApiResponse<OcrDocumentTag[]>>(
      url,
      this.store
    );

    return resposne?.data?.data;
  }

  public async getOcrBatches(
    status: string,
    data: {
      page: number;
      search?: string;
      perPage: number;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<S3FileTracker> & { lastUpdatedAt: Date }> {
    const url = `${this.apiDomain}/api/ocr/batches/all`;

    const resposne = await http.post<PaginatedApiResponse<S3FileTracker>>(
      url,
      data,
      this.store
    );
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }
}
